import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { ReferralEnabled } from "@warrenio/api-spec/spec.oats.gen";

const queryKey: QueryKey = ["/payment/admin/referral_enabled"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<ReferralEnabled> => {
            return getResponseData(await client.GET("/payment/admin/referral_enabled", { signal }));
        },
    });
}

export const referralEnabledQueryAtom = atomFromStandardQueryOptions(getQuery);

//#region Mutations

export const toggleEnabledMutation = adminMutation((apiClient) => ({
    entity: "Referral enabled",
    operation: "update",
    requestFn: async ({ enabled }: { enabled: boolean }) =>
        await apiClient.PUT("/payment/admin/referral_enabled", {
            ...jsonEncodedBody,
            body: { enabled },
        }),
    invalidateQueryKey: queryKey,
}));

//#endregion Mutations
